import axiosInstance from "./axiosInstance";

let api = axiosInstance()

  export const getCountry = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/Country`, config)
  }

  export const getState = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/State/ByCriteria/2`, config)
  }
  
  export const getQualifications = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/Qualifications`, config)
  }

  export const getSources = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/Sources`, config)
  }

  export const getEmployementStatus = async(abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/EmployementStatus`, config)
  }

  

  